module.exports = __webpack_public_path__ + "static/media/facebook.9aec68f2.jpg";